import { getIconRegistry } from "../registry";
export class IconSet {
    constructor() {
        this.assetsPath = undefined;
        this.ns = undefined;
        this.fileExtension = ".svg";
    }
    componentWillLoad() {
        getIconRegistry().registerIconSet(this);
    }
    static get is() { return "ux-icon-set"; }
    static get properties() {
        return {
            "assetsPath": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Path where the asset files are served from"
                },
                "attribute": "assets-path",
                "reflect": false
            },
            "ns": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Namespace of the icon-set"
                },
                "attribute": "ns",
                "reflect": false
            },
            "fileExtension": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "File extension used to resolve the asset url"
                },
                "attribute": "file-extension",
                "reflect": false,
                "defaultValue": "\".svg\""
            }
        };
    }
}
//# sourceMappingURL=icon-set.js.map
